<template>
  <div class="alarm-data">
    <div class="alarm-data__info-container">
      <span class="alarm-data__title">
        {{$t('monitoring.module')}}:
      </span>
      {{ alarm.moduleName }}
    </div>
    <div class="alarm-data__info-container">
      <span class="alarm-data__title">{{$t('monitoring.alarm')}}:</span>
      {{ alarm.alarmName }}
    </div>
    <div class="d-flex justify-content-between">
      <div class="d-inline-flex flex-column">
        <div class="alarm-data__info-container">
          <span class="alarm-data__title">{{$t('monitoring.date-and-hour')}}:</span>
          <date-time-label
            :value="alarm.dateAndTime"
          />
        </div>
        <div
          v-if="alarm.offlineAlarm"
          class="alarm-data__info-container"
        >
          <span class="alarm-data__title">
            {{ $t('alarms-and-warnings.sample-date') }}:
          </span>
          <alarm-value-label
            :value="alarm.sampleDateTime"
            :time-zone="timeZoneUTC"
          />
        </div>
      </div>
      <div class="d-inline-flex flex-column">
        <div class="alarm-data__info-container">
          <span class="alarm-data__title">
            {{$t('monitoring.acted-alarm')}}:
          </span>
          {{ actedAlarmLabel }}
        </div>
        <div
          v-if="alarm.offlineAlarm"
          class="alarm-data__info-container"
        >
          <span
            data-test="offline-alarm-lot"
            class="alarm-data__title"
          >
            {{ $t('alarms-and-warnings.lot') }}:
          </span>
          {{ alarm.lot }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { timezones } from '@/constants/localizer';
import AlarmValueLabel from '../AlarmValueLabel';

export default {
  components: {
    AlarmValueLabel,
  },
  props: {
    alarm: {
      type: Object,
      required: true,
    },
  },
  computed: {
    actedAlarmLabel() {
      return this.alarm.actedAlarm ? this.$t('general.yes') : this.$t('general.no');
    },
  },
  data: () => ({
    timeZoneUTC: timezones.UTC,
  }),
};
</script>

<style lang="sass" scoped>
  @import "src/styles/defaults/mobile-first"

  .alarm-data
    &__title
      font-weight: bold
    &__info-container
      margin-bottom: 5px
      &_horizontal
        display: flex
        flex-direction: column
    +media-min-sm()
      &__info-container
        &_horizontal
          flex-direction: row
          justify-content: space-between
</style>
